// assistantOpenSiteBuilder(text, opts) — a WEBSITE ask, sent from the site
// builder (Nika 2026-10-28: "building websites should … work like lovable").
// The ask router (functions/assistantAskRoute.js) hands a 'website' intent
// here; every other ask keeps its own path.
//
//   • A site on screen (the builder at /preview, or a pane showing it —
//     preview functions/previewSite.js previewSiteInView): the ask is a
//     normal send. The transport names that site to the agent per send.
//   • No site on screen: the builder opens first, in its "Setting up your
//     site…" state, and the ask is sent. The first project write the agent
//     makes points the builder at the new site (previewAfterAiWrite).
//
// The ONE chat is the shell assistant, docked beside the builder for the
// session (functions/assistantDock.js promoteAssistantDockForOpen) — no
// placement preference is written. `opts` (optional):
//   images    the composer's image bag (sendPrompt's third slot)
//   attached  the turn's structured attachment (`{ refs?, canvas? }`)
//   mode      this ask's own output mode
//   event     the opening click (⌘ / Ctrl: the builder opens in a split)
// Returns true when the ask was sent, false when there was nothing to send.
export function assistantOpenSiteBuilder(text, opts) {
  const el = this
  const root = el && el.state && el.state.root
  const ask = typeof text === 'string' ? text.trim() : ''
  if (!root || typeof root.update !== 'function' || !ask) return false
  const o = opts && typeof opts === 'object' ? opts : {}
  if (!el.call('previewSiteInView', root)) {
    // No site on screen: a builder that shows none waits for the new site;
    // otherwise the builder opens for it — never on a previous site's
    // carrier (`_previewParams`, the Studio sidebar's).
    const shown = el.call('previewBuilderOnScreen', root)
    if (!shown) root.update({ _previewParams: null })
    root.update({ _previewSiteStatus: 'setup', _previewSiteStep: null })
    if (!shown) {
      const e = o.event
      el.call(
        'openAppPage',
        '/preview',
        e && (e.metaKey || e.ctrlKey) ? { split: true } : undefined
      )
    }
  }
  // The chat opens beside the builder (an open drawer stays as it is).
  if (!root.assistantOpen) root.update({ assistantOpen: true, _homeThreadOpen: false })
  el.call('sendPrompt', ask, undefined, o.images, o.attached, o.mode ? { mode: o.mode } : undefined)
  return true
}
